export default __webpack_public_path__ + "static/media/Incident-Response.bd687f33.png";